<template>
    <div
        v-if="invoice.isPayoffRequired() && invoice.payoffMethod === 'sepa-credit-transfer'"
        class="kgr-tooltip kgr-tooltip--top"
    >
        <div
            class="kgr-tooltip__trigger"
        >
            <span
                class="kgr-badge kgr-badge--warning"
            >
                {{ $t('SEPA-Überweisung') }}
            </span>
        </div>
        <div
            class="kgr-tooltip__content kgr-region kgr-region--small kgr-region--default"
            style="width: 400px;"
        >
            {{ payoffText }}
        </div>
    </div>
    <div
        v-else-if="invoice.isPaymentRequired() && invoice.paymentMethod === 'sepa-debit'"
        class="kgr-tooltip kgr-tooltip--top"
    >
        <div
            class="kgr-tooltip__trigger"
        >
            <span
                class="kgr-badge kgr-badge--warning"
            >
                {{ $t('SEPA-Lastschrift') }}
            </span>
        </div>
        <div
            class="kgr-tooltip__content kgr-region kgr-region--small kgr-region--default"
            style="width:400px;"
        >
            {{ paymentText }}
        </div>
    </div>
</template>

<script>
import ClubInvoice from '../../../js/dto/ClubInvoice.js';

export default {
    props: {
        invoice: {
            type: ClubInvoice,
            required: true,
        },
    },
    computed: {
        paymentText() {
            return 'Der ausstehende Betrag in Höhe von ' + this.paymentDue() + ' kann per Sepa-Lastschrift eingezogen werden';
        },
        payoffText() {
            return 'Der ausstehende Betrag in Höhe von ' + this.paymentDue() + ' kann per Sepa-Überweisung ausgeglichen werden';
        }
    },
    methods: {
        paymentDue() {
            return this.invoice.getBalance().toFixed(2) + ' ' + this.invoice.currency;
        }
    },
}
</script>
